import React, { useState, useEffect, useRef } from "react";
import LogoOverlayComponent from "../dashboard/settings/LogoOverlayComponent";
import { S3 } from "../../constants";
import MobileCalendarPreview from "../dashboard/settings/MobileCalendarPreview";
import DailyDashboardPreview from "../dashboard/settings/DailyDashboardPreview";

const BuildApp = ({ customBranding }) => {
  const [progress, setProgress] = useState(0);

  const timer = useRef(undefined);

  useEffect(() => {
    if (!timer.current) {
      timer.current = setInterval(() => {
        setProgress((prev) => {
          if (prev < 4) {
            return prev + 1;
          }
          if (prev === 4) {
            clearInterval(timer.current);
          }
          return prev;
        });
      }, 1000);
    }

    return () => {
      if (timer.current) clearInterval(timer.current);
    };
  }, []);

  const {
    splashOverlayColor,
    splashOverlayOpacity,
    mobileSplashBg,
    mobileSplashImg,
    tintSplashImg,
    appTheme,
    appMainColor,
    appSecondaryTextColor,
  } = customBranding;

  const backgroundImage =
    mobileSplashBg && mobileSplashBg.s3Path
      ? `${S3.PATH}${mobileSplashBg.s3Path}`
      : null;

  return (
    <main role="build-app" className="Onboarding">
      <article>
        <div className="flex items-center">
          <div className="section phone-template" style={{ left: "7%" }}>
            <div className="background-container">
              <MobileCalendarPreview
                theme={appTheme}
                brandingColor={appMainColor}
                isDefaultColor={false}
                secondaryTextColor={appSecondaryTextColor}
              />
            </div>
            <img alt="phone" src="/img/iphone-template.webp" />
          </div>
          <div className="section phone-template !z-10">
            <div
              className="background-container"
              style={{
                backgroundImage: backgroundImage
                  ? `url(${backgroundImage})`
                  : undefined,
                backgroundColor: "var(--background-color)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            >
              <LogoOverlayComponent
                opacity={splashOverlayOpacity}
                overlayColor={splashOverlayColor}
                withOverlay={!!splashOverlayColor}
                withLogo
                logo={mobileSplashImg}
                isTinted={tintSplashImg}
              />
            </div>
            <img alt="phone" src="/img/iphone-template.webp" />
          </div>
          <div className="section phone-template" style={{ right: "7%" }}>
            <div className="background-container">
              <DailyDashboardPreview
                theme={appTheme}
                brandingColor={appMainColor}
                isDefaultColor={false}
                secondaryTextColor={appSecondaryTextColor}
              />
            </div>
            <img alt="phone" src="/img/iphone-template.webp" />
          </div>
        </div>

        <h3>Building Your App</h3>
        <p>
          {progress === 1
            ? "Almost there..."
            : progress === 2
            ? "Adding theme and colors..."
            : progress === 3
            ? "Adding logo..."
            : "Adjusting preferences..."}
        </p>
        <progress max={4} value={progress} />
      </article>
    </main>
  );
};

export default BuildApp;
